module.exports = __webpack_public_path__ + "images/404.1789097746312.png";